// extracted by mini-css-extract-plugin
module.exports = {"wrap":"App_wrap__2G_-o","unpressedCategory":"App_unpressedCategory__3aueb","category":"App_category__j8LHU"};